import { usePage } from '@inertiajs/vue3';

export default function useConfig() {
    return usePage().props.config;
}
